export class StatusProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "blockers",
            "baseName": "blockers",
            "type": "Array<ResourceBlockerDetail>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StatusProperties.attributeTypeMap;
    }
    constructor() {
    }
}
